import React from 'react';
import { connect } from 'react-redux';

class Q_1 extends React.Component {
    constructor(props) {
        super(props);

        this.gotoNextStep = this.gotoNextStep.bind(this);
    }

    formatHtml(message) {
        message = message.replace(/(&nbsp;)/gi, ' '); // in ' ' is non-breaking-space (U+00A0) which will be replaced by real &nbsp; by react.
        // message = message.replace(/(<br>)/ig, '\n');
        // message = message.replace(/(<\/br>)/ig, '\n');
        return message;
    }

    gotoNextStep(e) {
        e.preventDefault();

        this.props.saveValues({
            categoryOffline: e.target.dataset['offline'] === 'true',
            categoryOfflineDescription: e.target.dataset['offlinedescription'] || null
        });

        this.props.nextStep('Q_2');
    }

    render() {
        return (
            <div className="click2call--groups">
                <div className="click2call--group click2call--group-label">
                    <p>Wybierz numer aby połączyć się z doradcą:</p>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-singleradio">
                        {this.props.config.quick.callCategories.map((category, i) => (
                            <span key={i}>
                                <button
                                    onClick={this.gotoNextStep}
                                    value={category.categoryName}
                                    data-offline={category.categoryOffline || false}
                                    data-offlinedescription={category.categoryOfflineDescription}
                                    dangerouslySetInnerHTML={{
                                        __html: category.categoryName
                                    }}
                                />
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        config: state.config.widget.callOptions
    };
};

export default connect(mapStateToProps)(Q_1);
